/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M5 12l5 5l10 -10", "key": "svg-0" }]];
const IconCheck = createReactComponent("outline", "check", "Check", __iconNode);

export { __iconNode, IconCheck as default };
//# sourceMappingURL=IconCheck.mjs.map
